/* LUXX COSMETIC · Brands A–Z (/pages/all-brands, sections/luxx-markalar.liquid)
   Liste sunucuda çizilir (shop.vendors, harflere göre). Burada: öne çıkan logoların eşit görsel ağırlığı, yazdıkça süzen arama,
   yapışkan harf şeridi (seçili harf siyah) ve telefonda uzun grupları aç / kapat. Ortak API: window.LUXX (luxx-site.js). */
(() => {
  'use strict';
  const X = window.LUXX;
  if (!X || !document.getElementById('mkDizin')) return;
  const { $, $$, kac, norm, binlik } = X;
  const T = X.t, Tn = X.tn;   // çeviri (window.LUXX_T, locales "js.*")
  const hepsiMetni = (n, h) => T('markalar.show_all_letter', { n: binlik(n), letter: harfAdi(h) });
  const MOBIL = matchMedia('(max-width: 1099px)');
  const harfAdi = h => (h === '#' ? '0–9' : h);
  const TOPLAM = $$('.mk-liste a').length;
  const aramaUrl = q => `${X.A.routes.search}?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last`;

  // süzme anahtarı ve grup sayıları
  $$('.mk-liste a').forEach(a => { a.dataset.isim = norm(a.textContent); });
  $$('.mk-grup').forEach(g => { const s = $('[data-grup-sayi]', g); if (s) s.textContent = T('markalar.brands_count', { n: binlik($$('.mk-liste li', g).length) }); });
  $$('.mk-hepsi').forEach(b => { b.textContent = hepsiMetni(b.dataset.n, b.closest('.mk-grup').dataset.harf); });

  /* ---------- Öne çıkan resmi logolar: boş kenar kırpılır, mürekkep alanı her kutuda aynı büyüklüğe getirilir ---------- */
  function logoAgirlik(img) {
    const w = img.naturalWidth, h = img.naturalHeight;
    if (!w || !h) return;
    let x0 = 0, y0 = 0, x1 = w - 1, y1 = h - 1;
    try {
      const c = document.createElement('canvas'); c.width = w; c.height = h;
      const cx = c.getContext('2d', { willReadFrequently: true }); cx.drawImage(img, 0, 0);
      const d = cx.getImageData(0, 0, w, h).data;
      x0 = w; y0 = h; x1 = 0; y1 = 0;
      for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
        const i = (y * w + x) * 4;
        if (d[i + 3] > 40 && (d[i] < 225 || d[i + 1] < 225 || d[i + 2] < 225)) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      }
      if (x1 <= x0) { x0 = 0; y0 = 0; x1 = w - 1; y1 = h - 1; }
    } catch { /* CORS yoksa bütün görsel */ }
    const iw = x1 - x0 + 1, ih = y1 - y0 + 1, oran = iw / ih;
    const kutu = img.parentElement.getBoundingClientRect();
    const alan = Math.min(kutu.width * kutu.height * 0.2, 3000);
    let gw = Math.sqrt(alan * oran), gh = gw / oran;
    const mw = kutu.width - 36, mh = kutu.height - 30;
    if (gw > mw) { gw = mw; gh = gw / oran; }
    if (gh > mh) { gh = mh; gw = gh * oran; }
    const k = gw / iw;
    Object.assign(img.style, { maxWidth: 'none', width: w * k + 'px', height: h * k + 'px', margin: `${-y0 * k}px ${-(w - x1 - 1) * k}px ${-(h - y1 - 1) * k}px ${-x0 * k}px` });
    img.classList.add('tartildi');
  }
  const logolariTart = () => $$('.mk-logo img').forEach(img => (img.complete && img.naturalWidth ? logoAgirlik(img) : img.addEventListener('load', () => logoAgirlik(img), { once: true })));
  logolariTart();
  let enOnce = innerWidth;
  addEventListener('resize', () => { if (Math.abs(innerWidth - enOnce) > 40) { enOnce = innerWidth; logolariTart(); } });

  // telefonda grubu aç / kapat
  $('#mkDizin').addEventListener('click', e => {
    const b = e.target.closest('.mk-hepsi'); if (!b) return;
    const g = b.closest('.mk-grup'), acik = !g.classList.contains('acik');
    g.classList.toggle('acik', acik); b.setAttribute('aria-expanded', acik);
    const n = $$('.mk-liste li', g).length;
    b.textContent = acik ? T('markalar.show_fewer') : hepsiMetni(n, g.dataset.harf);
    if (!acik) { const y = g.getBoundingClientRect().top + scrollY - ustBosluk(); if (scrollY > y) scrollTo({ top: y }); }
  });

  /* ---------- Yapışkan ölçüler: header'ın görünen yüksekliği + harf şeridi ---------- */
  const hd = $('#hd'), serit = $('#mkSerit'), harfler = $('#mkHarfler');
  const hdYuk = () => (hd ? Math.max(0, hd.offsetHeight + (parseFloat(getComputedStyle(hd).top) || 0)) : 0);
  const ustBosluk = () => hdYuk() + serit.offsetHeight + 12;
  function ustAyarla() {
    document.documentElement.style.setProperty('--hd-yuk', hdYuk() + 'px');
    document.documentElement.style.setProperty('--mk-ust', ustBosluk() + 'px');
  }
  if (hd && 'ResizeObserver' in window) new ResizeObserver(ustAyarla).observe(hd);
  addEventListener('resize', ustAyarla);
  ustAyarla();

  /* ---------- Seçili harf: tıklayınca o gruba gider, kaydırınca izler ---------- */
  let aktif = '';
  function aktifYap(h) {
    if (h === aktif) return;
    aktif = h;
    $$('.mk-tus[data-harf]', harfler).forEach(t => {
      const on = t.dataset.harf === h;
      t.classList.toggle('secili', on);
      on ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current');
    });
    // mobilde şerit seçili harfi görünür tutar (sayfayı dikey kaydırmadan)
    const t = $(`.mk-tus[data-harf="${CSS.escape(h)}"]`, harfler);
    if (t && harfler.scrollWidth > harfler.clientWidth) {
      const sol = t.offsetLeft - harfler.offsetLeft, sag = sol + t.offsetWidth, pay = 48;
      if (sol - pay < harfler.scrollLeft) harfler.scrollTo({ left: sol - pay, behavior: 'smooth' });
      else if (sag + pay > harfler.scrollLeft + harfler.clientWidth) harfler.scrollTo({ left: sag + pay - harfler.clientWidth, behavior: 'smooth' });
    }
  }
  // header kaydırınca küçüldüğü için hedef kayar: kaydırma bitip header oturduktan sonra bir kez düzeltilir
  let gidis = 0;
  function harfeGit(h, yumusak = true) {
    const g = document.getElementById('letter-' + encodeURIComponent(h)); if (!g || g.hidden) return;
    const fark = () => g.getBoundingClientRect().top - ustBosluk() + 4;
    const git = davranis => scrollTo({ top: fark() + scrollY, behavior: davranis });
    const tur = ++gidis;
    let zaman;
    // yumuşak kaydırma başlarken erken bir "scrollend" gelebiliyor: grup henüz uzaktaysa asıl bitişi bekle (zaman aşımı yine düzeltir)
    const duzelt = e => {
      if (e && Math.abs(fark()) > 200) return;
      removeEventListener('scrollend', duzelt); clearTimeout(zaman);
      setTimeout(() => { if (tur === gidis && Math.abs(fark()) > 3) git('instant'); }, 260);
    };
    addEventListener('scrollend', duzelt);
    zaman = setTimeout(duzelt, yumusak ? 1500 : 60);
    git(yumusak ? 'smooth' : 'instant');
    aktifYap(h);
    history.replaceState(null, '', '#letter-' + encodeURIComponent(h));
  }
  harfler.addEventListener('click', e => {
    const t = e.target.closest('.mk-tus[data-harf]'); if (!t) return;
    e.preventDefault();
    harfeGit(t.dataset.harf);
  });
  let bekle = false;
  function izle() {
    bekle = false;
    const sinir = ustBosluk() + 8;
    let h = '';
    for (const g of $$('.mk-grup:not([hidden])')) { if (g.getBoundingClientRect().top <= sinir) h = g.dataset.harf; else break; }
    if (!h) { const ilk = $('.mk-grup:not([hidden])'); h = ilk ? ilk.dataset.harf : ''; }
    aktifYap(h);
  }
  addEventListener('scroll', () => { if (!bekle) { bekle = true; requestAnimationFrame(izle); } }, { passive: true });

  /* ---------- Yazdıkça süzen arama ---------- */
  const giris = $('#mkAra'), durum = $('#mkDurum'), yok = $('#mkYok'), dizin = $('#mkDizin'), logolar = $('.mk-logolar');
  const vurgula = (ad, q) => {
    const i = norm(ad).indexOf(q);
    return i < 0 || norm(ad).length !== ad.length ? kac(ad) : `${kac(ad.slice(0, i))}<mark>${kac(ad.slice(i, i + q.length))}</mark>${kac(ad.slice(i + q.length))}`;
  };
  function suz() {
    const qHam = giris.value.trim(), q = norm(qHam);
    dizin.classList.toggle('araniyor', !!q);
    if (logolar) logolar.hidden = !!q;
    let toplam = 0;
    $$('.mk-grup').forEach(g => {
      let n = 0;
      $$('.mk-liste a', g).forEach(a => {
        const ad = a.textContent, uy = !q || a.dataset.isim.includes(q);
        a.parentElement.hidden = !uy;
        a.innerHTML = q && uy ? vurgula(ad, q) : kac(ad);
        if (uy) n++;
      });
      g.hidden = !n; toplam += n;
      const t = $(`.mk-tus[data-harf="${CSS.escape(g.dataset.harf)}"]`, harfler);
      if (t) t.classList.toggle('bos', !n);
    });
    durum.textContent = q ? (toplam ? Tn('markalar.brands_match', toplam, { n: binlik(toplam), q: qHam }) : T('ortak.no_brand_matches', { q: qHam })) : T('markalar.brands_count', { n: binlik(TOPLAM) });
    yok.hidden = !!toplam || !q;
    if (q && !toplam) yok.innerHTML = `<p class="mk-yok-baslik">${X.X_ISARET}${kac(T('ortak.no_brand_matches', { q: qHam }))}</p><p>${T('markalar.try_another_spelling_html', { url: aramaUrl(qHam), q: kac(qHam) })}</p>`;
    aktif = ''; izle();
  }
  giris.addEventListener('input', suz);
  giris.addEventListener('keydown', e => {
    const gorunen = () => $$('.mk-liste li:not([hidden]) a').filter(a => a.offsetParent);
    if (e.key === 'Enter') {
      e.preventDefault();
      const q = norm(giris.value.trim()); if (!q) return;
      const l = gorunen(), tam = l.find(a => a.dataset.isim === q) || l.find(a => a.dataset.isim.startsWith(q)) || l[0];
      location.href = tam ? tam.href : aramaUrl(giris.value.trim());
    } else if (e.key === 'ArrowDown') {
      const ilk = gorunen()[0]; if (ilk) { e.preventDefault(); ilk.focus(); }
    } else if (e.key === 'Escape' && giris.value) { giris.value = ''; suz(); }
  });
  // listede ↑/↓ ile gezinme, en üstten aramaya dönüş
  $('.mk-liste-alan').addEventListener('keydown', e => {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    const l = $$('.mk-liste li:not([hidden]) a').filter(a => a.offsetParent), i = l.indexOf(document.activeElement);
    if (i < 0) return;
    e.preventDefault();
    if (e.key === 'ArrowUp' && i === 0) giris.focus(); else (l[i + (e.key === 'ArrowDown' ? 1 : -1)] || l[i]).focus();
  });

  /* ---------- Açılış: #letter-L bağlantısıyla gelindiyse o harfe ---------- */
  const hashHarf = () => decodeURIComponent((location.hash.match(/^#letter-(.+)$/) || [])[1] || '');
  const ilkHarf = hashHarf();
  if (ilkHarf) addEventListener('load', () => document.fonts.ready.then(() => requestAnimationFrame(() => harfeGit(ilkHarf, false))), { once: true });
  addEventListener('hashchange', () => { const h = hashHarf(); if (h) harfeGit(h, false); });
  MOBIL.addEventListener('change', () => { aktif = ''; izle(); });
  izle();
})();
